import React, { memo, useState } from "react";
import { formats } from "investira.sdk";
import { Button, Icon, Typography, LoadingButton, Dialog, DialogTitle, DialogContent, DialogActions } from "investira.react.components";
const PosicaoDeleteButtonDialog = memo(props => {
  const {
    onDelete,
    disabled,
    dataPosicao
  } = props;
  const [open, setOpen] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);
  function handleDelete() {
    setSubmitting(true);
    onDelete && onDelete(null, null, () => {
      setSubmitting(false);
      setOpen(false);
    });
  }
  return <>
      <LoadingButton disabled={isSubmitting || disabled} variant="contained" color="error" startIcon={<Icon iconName="delete" size={14} />} size="small" sx={{
      px: 2
    }} onClick={() => setOpen(true)} loading={isSubmitting}>
        Excluir Posição
      </LoadingButton>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>
          Excluir posição em{" "}
          {formats.formatDateCustom(dataPosicao, "DD/MM/YYYY")}
        </DialogTitle>
        <DialogContent>
          <Typography color="textPrimary" variant="body2">
            Tem certeza que deseja excluir toda a posição desta data? Esta ação
            não poderá ser desfeita.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancelar</Button>
          <LoadingButton variant="contained" type="button" onClick={handleDelete} loading={isSubmitting} disabled={isSubmitting} color="error">
            Excluir
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>;
});
export default PosicaoDeleteButtonDialog;
